import { Component, inject } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { MatExpansionModule } from '@angular/material/expansion';
import { MatIconModule } from '@angular/material/icon';
import { MatListModule } from '@angular/material/list';
import { MatSelectModule } from '@angular/material/select';
import { MatSidenavModule } from '@angular/material/sidenav';
import { MatToolbarModule } from '@angular/material/toolbar';
import { Router, RouterLink, RouterLinkActive, RouterOutlet } from '@angular/router';
import { AppStore } from './app.store';
import { LoginService } from './core/auth/login.service';
import { CountryDomainService } from './core/country/country-domain.service';
import { CountryCode, ALL_COUNTRIES, COUNTRY_LABELS } from './core/country/country.model';
import { StatusChipComponent } from './pages/customers/shared/status-chip.component';
import { AiAgentChatPanelComponent } from './shared/ai-agent-chat/ai-agent-chat-panel.component';

@Component({
    selector: 'na-root',
    imports: [
        RouterOutlet,
        RouterLink,
        RouterLinkActive,
        MatSidenavModule,
        MatToolbarModule,
        MatButtonModule,
        MatIconModule,
        MatListModule,
        MatSelectModule,
        MatExpansionModule,
        AiAgentChatPanelComponent,
        StatusChipComponent,
    ],
    templateUrl: './app.html',
    styleUrl: './app.scss',
})
export class AppComponent {
    protected readonly store = inject(AppStore);
    protected readonly countryDomainService = inject(CountryDomainService);
    protected readonly allCountries = ALL_COUNTRIES;
    protected readonly countryLabels = COUNTRY_LABELS;

    private readonly loginService = inject(LoginService);
    private readonly router = inject(Router);

    onCountryChange(country: CountryCode): void {
        this.countryDomainService.setCountry(country);
    }

    logout(): void {
        this.loginService.logout().subscribe({
            next: () => this.router.navigate(['/login']),
            error: () => this.router.navigate(['/login']),
        });
    }
}
